
































































import { loadStripe } from "@stripe/stripe-js/pure";
import Vue from "vue";
import { initStripe } from "@stripe/stripe-js/src/shared";
import { createPaymentMethod } from "@/helpers/stripe";
import { bus } from "@/main";
import { createNewSubscription, getStripePKey } from "@/helpers/api";
import {
  NewSubscriptionInitializer,
  NewSubscriptionVO
} from "@/types/REST-API-DOMAIN/NewSubscriptionVO";
import { getModule } from "vuex-module-decorators";
import SubscriptionSignup from "@/store/modules/SubscriptionSignup";
import LicenseTotal from "@/components/Subscriptions/LicenseTotal.vue";
import PayAsYouGoTotals from "@/components/Subscriptions/PayAsYouGoTotals.vue";
import PromoCodeField from "@/components/Subscriptions/PromoCodeField.vue";
import TermsAndPrivacy from "@/components/Subscriptions/TermsAndPrivacy.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import GetterTypes from "@/store/GetterTypes";
import { Routes } from "@/router/Routes";
import ActionTypes from "@/store/ActionTypes";
import MutationTypes from "@/store/MutationTypes";
import { OrgAccess } from "@/types/REST-API-DOMAIN/OrgAccess";

interface State {
  store: SubscriptionSignup;
  stripe: any;
  elements: any;
  card: any;
  newOrgId: string | null;
  showSubscriptionConfirmation: boolean;
}

export default Vue.extend({
  name: "SubscriptionCheckout",
  components: {
    PayAsYouGoTotals,
    LicenseTotal,
    TermsAndPrivacy
  },
  data(): State {
    return {
      store: getModule(SubscriptionSignup, this.$store),
      stripe: null,
      elements: null,
      card: null,
      newOrgId: null,
      showSubscriptionConfirmation: false
    };
  },
  async mounted() {
    if (!this.store.subscriptionVO.orgName) {
      if (!this.$route.params.orgId) {
        this.$router.push(Routes.SUBSCRIPTIONS_SIGNUP);
      } else {
        this.store.setExistingOrg({
          orgName: this.selectedOrg.name,
          orgId: this.selectedOrg.id
        } as OrgAccess);
        this.$router.push(`/${this.selectedOrg.id}/subscriptions/licenses`);
      }
    } else if (!this.store.subscriptionVO.teams) {
      if (this.$route.params.orgId) {
        this.$router.push(`/${this.selectedOrg.id}/subscriptions/licenses`);
      } else {
        this.$router.push(Routes.SUBSCRIPTIONS_LICENSES);
      }
    } else if (!this.store.selectedLicense) {
      if (this.$route.params.orgId) {
        this.$router.push(`/${this.selectedOrg.id}/subscriptions/licenses`);
      } else {
        this.$router.push(Routes.SUBSCRIPTIONS_LICENSES);
      }
    }
    await this.initStripe();
  },
  methods: {
    ...mapMutations({
      setSelectedOrg: MutationTypes.SET_ORG_UNIT_SELECTION
    }),
    async initStripe() {
      const spk = await getStripePKey();
      this.stripe = await loadStripe(spk);
      this.elements = await this.stripe.elements();
      setTimeout(() => {
        this.createCard();
        const signupForm: any = document.getElementById("payment-form");
        signupForm.addEventListener("submit", (evt: any) => {
          evt.preventDefault();
          this.handleSubscriptionSignup();
        });
      }, 100);
    },
    async handleSubscriptionSignup() {
      //Loading Overlay
      bus.$emit("loadingOn", "Processing...");

      //Create Payment Method
      const paymentMethodId:
        | string
        | null = await this.handleCreatePaymentMethod();
      if (!paymentMethodId) {
        bus.$emit("loadingOff");

        bus.$emit(
          "errorSnack",
          "An error occurred verifying your payment method, please try again."
        );
        return;
      }

      //Build SubscriptionObject
      const sub: NewSubscriptionVO = this.store.subscriptionVO;
      sub.paymentMethodId = paymentMethodId;

      if (!sub.promotion) {
        sub.couponCode = null;
      } else {
        sub.promotionId = this.store.isLicenseDiscount
          ? sub.promotion.id
          : null;
        sub.usagePromotionId =
          this.store.isConnectDiscount || this.store.isDataDiscount
            ? sub.promotion.id
            : null;
      }

      sub.promotion = null;

      if (sub.newUser.username.length > 1) {
        sub.user = sub.newUser;
      } else {
        sub.user = this.user;
      }

      //Send payment Method ID to Backend to handle remainder of account Setup
      createNewSubscription(sub)
        .then(resp => {
          console.log(resp);
          if (!resp.data) {
            bus.$emit("loadingOff");
            bus.$emit(
              "errorSnack",
              "An error occurred creating your organization, please try again."
            );
            return;
          }
          bus.$emit("loadingOff");
          bus.$emit("successSnack", "Success!");
          this.newOrgId = resp.data;
          this.showSubscriptionConfirmation = true;
        })
        .catch(error => {
          bus.$emit("loadingOff");
          if (error.response) {
            bus.$emit(
              "errorSnack",
              error.response.data.message + " - Please try again."
            );
          } else {
            bus.$emit(
              "errorSnack",
              error + "An error has occurred, please try again."
            );
          }
        });

      //Loading Off
    },

    createCard() {
      const style = {
        base: {
          color: "#000000",
          iconColor: "#000000",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          boxSizing: "border-box",
          borderRadius: "15px",
          padding: "10px",
          fontSize: "16px",
          "::placeholder": {
            color: "#000000",
            iconColor: "#000000"
          }
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a"
        }
      };

      // Create an instance of the card Element.
      this.card = this.elements.create("card", { style: style });
      console.log(this.card);
      this.card.mount("#card-element");
      this.card.on("change", (event: any) => {
        this.displayError(event);
      });
    },
    async handleCreatePaymentMethod(): Promise<string | null> {
      return await createPaymentMethod(
        this.stripe,
        this.card,
        this.$route.params.orgId ? this.selectedOrg.name : "OrgName"
      ).then((result: any) => {
        if (result.error) {
          // this.error = result.error;
          return null;
        } else {
          return result.paymentMethod.id;
        }
      });
    },

    displayError(event: any) {
      const displayError: any = document.getElementById("card-element-errors");
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = "";
      }
    },
    previousPage() {
      this.$route.params.orgId
        ? this.$router.push(`/${this.$route.params.orgId}/subscriptions/select`)
        : this.$router.push(`/subscriptions/select`);
    },
    redirectToDashboard() {
      if (this.$route.params.orgId) {
        // If creating a new subscription for an org with a subscription that has expired. Reload TeamBot to init global state and fetch updated subscription data.
        window.location.href = `/${this.$route.params.orgId}/teams`;
      } else {
        window.location.href = `/createteam/${this.newOrgId}?orgId=${this.newOrgId}`;
      }
    }
  },
  computed: {
    ...mapGetters({
      user: GetterTypes.GET_USER,
      selectedOrg: GetterTypes.GET_ORGANIZATION
    })
  }
});
